<template>
  <div class="white_container reserved_container">
    <h4>{{lesson.title}}</h4>
    <h2>{{lesson.header}}</h2>
    <p v-if="isSoonLesson===1">{{lesson.description}}</p>
    <p v-if="isSoonLesson===0">Lecția de probă a fost rezervată pentru data de {{textDate}}, ora <br/>
      {{textTime}} și va începe pe această pagină în:</p>
    <div class="timer"></div>
    <Countdown :date="stringToDateTimePlaned" v-on:onTick="onTick"></Countdown>
    <a v-if="isSoonLesson===1" :href="lesson.link" target="_blank" class="button with_icon"><i
        class="icon-play-circle"></i><span>Start apel</span></a>
    <button v-if="isSoonLesson===0" class="button" @click="changeAnyDate">
      <span>Alege altă dată</span>
    </button>
    <p v-if="isSoonLesson===1" class="start_container_text">După click, veți lua legătura cu profesorul.</p>
  </div>
</template>

<script>
  import store from '@/store';
  import Countdown from '../Countdown';
  import { dateConvert, dateConvertToNumber, isSoonDate } from '../../../../utils/utils';

  export default {
    name: "Paid",
    components: {
      Countdown
    },
    props: {
      lesson: {
        type: Object,
        default: {}
      },
    },
    data: function () {
      return {
        isSoonLesson: -1,
      }
    },
    computed: {
      stringToDateTimePlaned() {
        return dateConvertToNumber(this.lesson.datetime);
      },
      textDate() {
        if (this.lesson.datetime !== ''){
          let date = this.lesson.datetime.split(' ')[0];
          return dateConvert(date)
        }
        return '';
      },
      textTime() {
        if (this.lesson.datetime !== ''){
          return this.lesson.datetime.split(' ')[1];
        }
        return '';
      }
    },
    mounted() {
      this.isSoonLesson = isSoonDate(this.lesson.datetime, 10 * 60);

    },
    methods: {
      onTick(time) {
        if ((time - 10 * 60) <= 0) {
          this.isSoonLesson = 1
        } else {
          this.isSoonLesson = 0
        }
      },
      changeAnyDate() {
        store.commit('user/is_planned', 0);
      },
    }
  }
</script>

<style scoped lang="scss">
  .button {
    padding: 0.75rem 2.5rem 1rem 2.5rem;
    margin-bottom: 6.2rem;
  }
  .timer {
    margin-top: 10.5rem;
  }

  .reserved_container{
    text-align: center;
    padding: 6rem 1.5rem 4rem;
    .button{
      margin-top: 12rem;
    }
    .start_container_text{
      margin-top: 2rem;
    }
  }
</style>
